

// 경로 정의 (평면화된 구조)
const ROUTES = {
    USER: {
        path: '', // fullpath: ''
        LOGIN: {
            path: 'login/', // fullpath: 'login/'
            methods: ['POST'],
            axiosInstance: 'axios', // 기본 axios 인스턴스
            headers: {
                'X-CSRFToken': 'csrftoken',
                'withCredentials': true
            }
        },
        LOGOUT: {
            path: 'logout/', // fullpath: 'logout/'
            methods: ['POST'],
            axiosInstance: 'axios', // 기본 axios 인스턴스
            headers: {
                'X-CSRFToken': 'csrftoken',
                'withCredentials': true
            }
        },
        TOKEN: {
            path: 'token', // fullpath: 'token'
            REFRESH: {
                path: 'refresh/', // fullpath: 'token/refresh/'
                methods: ['POST', 'GET'],
                axiosInstance: 'axios', // 기본 axios 인스턴스
                headers: {
                    'X-CSRFToken': 'csrftoken',
                    'withCredentials': true
                }
            }
        },
        PASSWORD: {
            path: 'password', // fullpath: 'password'
            CHANGE: {
                path: 'change/', // fullpath: 'password/change/'
                methods: ['POST'],
            }
        }
    },

    COMMON: {
        path: 'common', // fullpath: 'common'
        CODE: {
            path: 'code', // fullpath: 'common/code'
            methods: ['GET']
        },
        EMPLOYEE_SALARY: {
            path: 'view-salary', // fullpath: 'common/view-salary/{employeeNo}'
            dynamic: true,
            params: ['employeeNo'],
            template: 'view-salary/{employeeNo}',
            methods: ['GET']
        },
        WORK_TIME_FORMAT: {
            path: 'view-work-time-format', // fullpath: 'common/view-work-time-format/{employeeNo}'
            dynamic: true,
            params: ['employeeNo'],
            template: 'view-work-time-format/{employeeNo}',
            methods: ['GET']
        },
        WORK_TIME_FORMAT_LIST: {
            path: 'view-work-time-format', // fullpath: 'common/view-work-time-format'
            methods: ['GET']
        },
        INSURANCE_RATE: {
            path: 'insurance-rate', // fullpath: 'common/insurance-rate'
            methods: ['GET']
        },
        CRTLWH_TIME: {
            path: 'crtlwh', // fullpath: 'common/crtlwh'
            methods: ['GET']
        },
        TESTS: {
            path: 'tests', // fullpath: 'common/tests'
            methods: ['GET']
        },
        WORKDAYS: {
            path: 'workdays', // fullpath: 'common/workdays'
            methods: ['GET']
        }
    },

    MANAGEMENT: {
        path: 'management', // fullpath: 'management'
        CORPORATIONS: {
            path: 'corporations', // fullpath: 'management/corporations'
            methods: ['GET', 'POST']
        },
        CORPORATION: {
            path: 'corporation', // fullpath: 'management/corporation/{corp_no}'
            dynamic: true,
            params: ['corp_no'],
            template: 'corporation/{corp_no}',
            methods: ['GET', 'PUT']
        },
        BASIC_INFO: {
            path: 'basic-info', // fullpath: 'management/basic-info'
            COMPANY_INFO: {
                path: 'company-info', // fullpath: 'management/basic-info/company-info'
                DEPARTMENT: {
                    path: 'department', // fullpath: 'management/basic-info/company-info/department/{grp_no}'
                    dynamic: true,
                    params: ['grp_no'],
                    template: 'department/{grp_no}',
                    methods: ['GET']
                },
                POSITION: {
                    path: 'position', // fullpath: 'management/basic-info/company-info/position/{grp_no}'
                    dynamic: true,
                    params: ['grp_no'],
                    template: 'position/{grp_no}',
                    methods: ['GET']
                }
            },
            ATTENDANCE: {
                path: 'attendance', // fullpath: 'management/basic-info/attendance'
                methods: ['GET', 'POST', 'PUT', 'DELETE']
            },
            INSURANCE: {
                path: 'insurance', // fullpath: 'management/basic-info/insurance'
                methods: ['GET', 'POST', 'PUT', 'DELETE'],
                CURRENT: {
                    path: 'current', // fullpath: 'management/basic-info/insurance/current'
                    methods: ['GET']
                }
            },
            TAX: {
                path: 'tax', // fullpath: 'management/basic-info/tax'
                methods: ['GET']
            },
            SIMPLE_TAX: {
                path: 'simple-tax', // fullpath: 'management/basic-info/simple-tax'
                methods: ['GET'],
                EXCEL: {
                    path: 'excel', // fullpath: 'management/basic-info/simple-tax/excel'
                    methods: ['POST']
                }
            },
            HOLIDAY: {
                path: 'holiday', // fullpath: 'management/basic-info/holiday'
                methods: ['GET', 'POST', 'PUT', 'DELETE'],
                PREVIEW: {
                    path: 'preview', // fullpath: 'management/basic-info/holiday/preview'
                    methods: ['GET']
                },
                APPLY_TO_COMPANIES: {
                    path: 'apply-to-companies', // fullpath: 'management/basic-info/holiday/apply-to-companies'
                    methods: ['POST']
                }
            },
            SALARY: {
                path: 'salary', // fullpath: 'management/basic-info/salary'
                methods: ['GET']
            },
        },
        
        MANAGER: {
            path: 'manager', // fullpath: 'management/manager'
            methods: ['GET']
        },
        LOGIN_HISTORY: {
            path: 'login-history', // fullpath: 'management/login-history'
            methods: ['GET']
        }
        
    },

    BASIC_INFO: {
        path: 'basic-info', // fullpath: 'basic-info'
        INSURANCE: {
            path: 'insurance', // fullpath: 'basic-info/insurance'
            methods: ['GET']
        },
        COMPANY_INFO: {
            path: 'company-info', // fullpath: 'basic-info/company-info'
            DEPARTMENT: {
                path: 'department', // fullpath: 'basic-info/company-info/department'
                methods: ['GET', 'POST', 'PUT', 'DELETE']
            },
            POSITION: {
                path: 'position', // fullpath: 'basic-info/company-info/position'
                methods: ['GET', 'POST', 'PUT', 'DELETE']
            }
        },
        ATTENDANCE: {
            path: 'attendance', // fullpath: 'basic-info/attendance'
            methods: ['GET', 'POST', 'PUT', 'DELETE']
        },
        SALARY: {
            path: 'salary', // fullpath: 'basic-info/salary'
            methods: ['GET', 'POST', 'PUT', 'DELETE']
        },
        HOLIDAY: {
            path: 'holiday', // fullpath: 'basic-info/holiday'
            methods: ['GET', 'POST', 'PUT', 'DELETE']
        }
    },
    HRM: {
        path: 'hrm', // fullpath: 'hrm'
        EMPLOYEES: {
            path: 'employees', // hrm/employees, fullpath: 'hrm/employees'
            methods: ['GET', 'POST']
        },
        EMPLOYEE: {
            path: 'employee', // hrm/employee, fullpath: 'hrm/employee/{empl_no}'
            dynamic: true,
            params: ['empl_no'],
            template: 'employee/{empl_no}',
            methods: ['GET', 'POST', 'DELETE']
        }
    },

    ATTENDANCE: {
        path: 'attendance', // fullpath: 'attendance'
        WORK_TIME: {
            path: 'work-time', // fullpath: 'attendance/work-time/{atend_no}'
            dynamic: true,
            params: ['atend_no'],
            template: 'work-time/{atend_no}',
            methods: ['GET']
        },
        WORK_TIMES: {
            path: 'work-times', // fullpath: 'attendance/work-times'
            methods: ['GET', 'POST']
        },
        DAILY_WORKS: {
            path: 'daily-works', // fullpath: 'attendance/daily-works'
            methods: ['GET']
        },
        DAILY_WORK: {
            path: 'daily-work', // fullpath: 'attendance/daily-work/{empl_no}'
            dynamic: true,
            params: ['empl_no'],
            template: 'daily-work/{empl_no}',
            methods: ['GET', 'POST']
        },
        MANAGEMENT: {
            path: 'management', // fullpath: 'attendance/management'
            methods: ['GET', 'POST', 'PUT'],
            RECALCULATION: {
                path: 'recalculation', // fullpath: 'attendance/management/recalculation/{empl_no}'
                dynamic: true,
                params: ['empl_no'],
                template: 'recalculation/{empl_no}',
                methods: ['GET']
            }
        },
        RECALCULATION_ALL: {
            path: 'recalculate', // fullpath: 'attendance/recalculate'
            methods: ['POST']
        }
    },

    SALARY: {
        path: 'salary', // fullpath: 'salary'
        MANAGEMENT: {
            path: 'management', // fullpath: 'salary/management'
            methods: ['GET', 'POST', 'PUT', 'DELETE']
        },
        PAYMENT: {
            path: 'payment', // fullpath: 'salary/payment'
            methods: ['GET']
        },
        PAYMENT_YEAR_LIST: {
            path: 'payment-year-list', // fullpath: 'salary/payment-year-list'
            methods: ['GET']
        },
        TRANSFER: {
            path: 'transfer', // fullpath: 'salary/transfer'
            methods: ['GET']
        },
        LEAVE: {
            path: 'leave', // fullpath: 'salary/leave'
            methods: ['GET'],
            PAYMENT_LIST: {
                path: 'payment-list', // fullpath: 'salary/leave/payment-list'
                methods: ['GET']
            }
        },
        RETIREMENT_PENSION: {
            path: 'retirement-pension', // fullpath: 'salary/retirement-pension'
            methods: ['GET', 'PUT']
        },
        DEPARTURE: {
            path: 'departure', // fullpath: 'salary/departure'
            methods: ['GET']
        },
        ACCOUNT_BOOK: {
            path: 'account-book', // fullpath: 'salary/account-book'
            methods: ['GET']
        },
        BATCH_UPDATE: {
            path: 'batch', // fullpath: 'salary/batch'
            methods: ['POST']
        },
        DAILY: {
            path: 'daily', // fullpath: 'salary/daily'
            methods: ['GET'],
            BATCH: {
                path: 'batch', // fullpath: 'salary/daily/batch'
                methods: ['POST']
            },
            RECALCULATE: {
                path: 'recalculate', // fullpath: 'salary/daily/recalculate'
                methods: ['POST']
            }
        }
    },

    E_SYSTEM: {
        path: 'e-system', // fullpath: 'e-system'
        FORM: {
            path: 'form', // fullpath: 'e-system/form'
            methods: ['POST', 'PUT']
        },
        LIST: {
            path: 'list', // fullpath: 'e-system/list/{pageType}'
            dynamic: true,
            params: ['pageType'],
            template: 'list/{pageType}',
            methods: ['GET']
        },
        DETAIL: {
            path: 'detail', // fullpath: 'e-system/detail/{no}'
            dynamic: true,
            params: ['no'],
            template: 'detail/{no}',
            methods: ['GET']
        },
        RECALL: {
            path: 'recall', // fullpath: 'e-system/recall/{no}'
            dynamic: true,
            params: ['no'],
            template: 'recall/{no}',
            methods: ['PUT']
        },
        PRINT: {
            path: 'print', // fullpath: 'e-system/print/{no}'
            dynamic: true,
            params: ['no'],
            template: 'print/{no}',
            methods: ['GET']
        }
    },

    TERMINAL: {
        path: 'terminal', // fullpath: 'terminal'
        BEACON: {
            path: 'beacon', // fullpath: 'terminal/beacon'
            methods: ['GET'],
            DETAIL: {
                path: 'detail', // fullpath: 'terminal/beacon/detail/{companyNo}'
                dynamic: true,
                params: ['companyNo'],
                template: 'detail/{companyNo}',
                methods: ['GET']
            },
            WRITE: {
                path: 'write', // fullpath: 'terminal/beacon/write'
                methods: ['POST']
            },
            MODIFY: {
                path: 'modify', // fullpath: 'terminal/beacon/modify/{no}'
                dynamic: true,
                params: ['no'],
                template: 'modify/{no}',
                methods: ['GET']
            },
            MODIFY_DATA: {
                path: 'modifydata', // fullpath: 'terminal/beacon/modifydata'
                methods: ['POST']
            },
            MODIFY_DELETE: {
                path: 'modifydelete', // fullpath: 'terminal/beacon/modifydelete/{no}'
                dynamic: true,
                params: ['no'],
                template: 'modifydelete/{no}',
                methods: ['DELETE']
            }
        },
        MOBILE: {
            path: 'mobile', // fullpath: 'terminal/mobile/{companyNo}'
            dynamic: true,
            params: ['companyNo'],
            template: 'mobile/{companyNo}',
            methods: ['GET'],
            MODIFY: {
                path: 'modify', // fullpath: 'terminal/mobile/modify/{no}'
                dynamic: true,
                params: ['no'],
                template: 'modify/{no}',
                methods: ['GET']
            },
            DELETE: {
                path: 'modifydelete', // fullpath: 'terminal/mobile/modifydelete/{no}'
                dynamic: true,
                params: ['no'],
                template: 'modifydelete/{no}',
                methods: ['DELETE']
            }
        }
    },

    EXCEL: {
        path: 'excel', // fullpath: 'excel'
        DOWNLOAD: {
            path: 'download', // fullpath: 'excel/download/{type}'
            dynamic: true,
            params: ['type'],
            template: 'download/{type}',
            methods: ['GET'],
            axiosInstance: 'axiosInstance', // 커스텀 axios 인스턴스 사용
            responseType: 'blob', // 파일 다운로드를 위해 blob으로 설정
            headers: {}
        }
    },

    PDF: {
        path: 'pdf', // fullpath: 'pdf'
        DOWNLOAD: {
            path: 'download', // fullpath: 'pdf/download/{type}'
            dynamic: true,
            params: ['type'],
            template: 'download/{type}',
            methods: ['GET'],
            axiosInstance: 'axiosInstance', // 커스텀 axios 인스턴스 사용
            responseType: 'blob', // 파일 다운로드를 위해 blob으로 설정
            headers: {}
        }
    },

    BOARD: {
        path: 'board', // fullpath: 'board'
        NOTICE: {
            path: 'notice', // fullpath: 'board/notice'
            POSTS: {
                path: 'posts', // fullpath: 'board/notice/posts'
                methods: ['GET', 'POST']
            },
            POST: {
                path: 'post', // fullpath: 'board/notice/post/{no}'
                dynamic: true,
                params: ['no'],
                template: 'post/{no}',
                methods: ['GET', 'PUT', 'DELETE']
            },
            IMAGE: {
                path: 'image', // fullpath: 'board/notice/image'
                UPLOAD: {
                    path: 'upload', // fullpath: 'board/notice/image/upload'
                    methods: ['POST'],
                    axiosInstance: 'axiosInstance', // 커스텀 axios 인스턴스 사용
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
                GET: {
                    path: 'get', // fullpath: 'board/notice/image/get/{imageId}'
                    dynamic: true,
                    params: ['imageId'],
                    template: 'get/{imageId}',
                    methods: ['GET'],
                    axiosInstance: 'axiosInstance',
                    responseType: 'blob' // 이미지이므로 blob으로 받음
                }
            },
            POPUPS: {
                path: 'popups', // fullpath: 'board/notice/popups'
                methods: ['GET']
            }
        },
        FILE: {
            path: 'file', // fullpath: 'board/file'
            POSTS: {
                path: 'posts', // fullpath: 'board/file/posts'
                methods: ['GET', 'POST']
            },
            POST: {
                path: 'post', // fullpath: 'board/file/post/{no}'
                dynamic: true,
                params: ['no'],
                template: 'post/{no}',
                methods: ['GET', 'PUT', 'DELETE']
            },
            UPLOAD: {
                path: 'upload', // fullpath: 'board/file/upload'
                methods: ['POST'],
                axiosInstance: 'axiosInstance', // 커스텀 axios 인스턴스 사용
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            DOWNLOAD: {
                path: 'download', // fullpath: 'board/file/download/{fileId}'
                dynamic: true,
                params: ['fileId'],
                template: 'download/{fileId}',
                methods: ['GET'],
                axiosInstance: 'axiosInstance',
                responseType: 'blob' // 파일이므로 blob으로 받음
            }
        }
    }
};

// 동적 경로를 생성하는 헬퍼 함수
export const createDynamicPath = (route, params) => {
    if (!route.dynamic) {
        return route.path || route;
    }
    
    let path = route.template;
    route.params.forEach(param => {
        if (params[param]) {
            path = path.replace(`{${param}}`, params[param]);
        }
    });
    
    return path;
};

// API 엔드포인트를 생성하는 헬퍼 함수들
export const createAPIEndpoint = (basePath, route, params = {}) => {
    if (typeof route === 'string') {
        return `${basePath}/${route}`;
    }
    
    if (route.dynamic) {
        const dynamicPath = createDynamicPath(route, params);
        return `${basePath}/${dynamicPath}`;
    }
    
    return `${basePath}/${route.path}`;
};

// HTTP 메서드별 API 함수 생성을 위한 헬퍼
export const createAPIFunctions = (basePath, route, axiosInstance) => {
    const endpoint = createAPIEndpoint(basePath, route);
    
    const functions = {};
    
    if (route.methods) {
        route.methods.forEach(method => {
            const methodName = method.toLowerCase();
            console.log("methodName", methodName);
            
            switch (method) {
                case 'GET':
                    functions[`get${route.path.charAt(0).toUpperCase() + route.path.slice(1)}`] = 
                        (params = {}) => axiosInstance.get(endpoint, { params });
                    break;
                case 'POST':
                    functions[`create${route.path.charAt(0).toUpperCase() + route.path.slice(1)}`] = 
                        (data) => axiosInstance.post(endpoint, data);
                    break;
                case 'PUT':
                    functions[`update${route.path.charAt(0).toUpperCase() + route.path.slice(1)}`] = 
                        (data) => axiosInstance.put(endpoint, data);
                    break;
                case 'DELETE':
                    functions[`delete${route.path.charAt(0).toUpperCase() + route.path.slice(1)}`] = 
                        (data) => axiosInstance.delete(endpoint, { data });
                    break;
            }
        });
    }
    
    return functions;
};

// 공통 헤더
export const COMMON_HEADERS = {
    MULTIPART: {
        'Content-Type': 'multipart/form-data'
    }
};

// ROUTES 객체 export
export { ROUTES };
